/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  String utils
 */

var StringUtils = function(){};


/**
 * Static functions
 */


/**
 * Rot13 encode/decode
 * Jonas Raoni Soares Silva, http://jsfromhell.com/string/rot13 [rev. #1]
 * @param {string} input
 * @returns {string}
 */
StringUtils.rot13 = function(input){
    return input.replace(/[a-zA-Z]/g, function(c){
        return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
    });	
};


/**
 * Convert numeric value to native bool
 * @param {int} int
 * @returns {Boolean}
 */
StringUtils.intToBool = function(int){
	if(parseInt(int) > 0){
		return true;
	}
	return false;
};


/**
 * Convert string value true|false to native bool
 * @param {string} str
 * @returns {Boolean}
 */
StringUtils.stringToBool = function(str){
	if(str.trim().toLowerCase() === 'true'){
		return true;
	}
	return false;
};

